import React from 'react';
import { Problem, Step } from '../solver/types';

interface Props {
  problem: Problem;
  step: Step;
}

// Dibuja la tabla de transporte para un paso dado: costos, asignaciones,
// oferta/demanda restante, multiplicadores u/v y el ciclo resaltado.
const MatrixGrid: React.FC<Props> = ({ problem, step }) => {
  // Mapa de signos del ciclo (para mostrar +/-).
  const loopSign = new Map<string, '+' | '-'>();
  if (step.loop) {
    step.loop.forEach((c, idx) => {
      loopSign.set(`${c.r},${c.c}`, idx % 2 === 0 ? '+' : '-');
    });
  }

  // Mapa de costos reducidos en celdas no básicas (MODI).
  const deltaMap = new Map<string, number>();
  if (step.improvements) {
    step.improvements.forEach((x) => deltaMap.set(`${x.row},${x.col}`, x.delta));
  }

  return (
    <div className="grid-wrap">
      <table className="t-grid">
        <thead>
          <tr>
            <th className="corner" />
            {problem.dests.map((d, j) => (
              <th key={j} className="dest-h">
                {d}
                {step.v && step.v[j] !== null && (
                  <span className="uv">v={step.v[j]}</span>
                )}
              </th>
            ))}
            <th className="supply-h">Oferta</th>
          </tr>
        </thead>
        <tbody>
          {problem.sources.map((s, i) => (
            <tr key={i}>
              <th className="src-h">
                {s}
                {step.u && step.u[i] !== null && <span className="uv">u={step.u[i]}</span>}
              </th>
              {problem.dests.map((_, j) => {
                const a = step.alloc[i][j];
                const key = `${i},${j}`;
                const isHi = step.highlight?.row === i && step.highlight?.col === j;
                const sign = loopSign.get(key);
                const delta = deltaMap.get(key);
                const forb = problem.forbidden?.[i]?.[j];
                const cls = [
                  'cell',
                  a !== null ? 'basic' : 'empty',
                  isHi ? 'hi' : '',
                  forb ? 'forbidden' : '',
                  sign ? `loop loop-${sign === '+' ? 'plus' : 'minus'}` : '',
                ]
                  .filter(Boolean)
                  .join(' ');
                return (
                  <td key={`${j}-${a}-${sign ?? ''}`} className={cls}>
                    <span className="cost">{forb ? '✕' : problem.costs[i][j]}</span>
                    {a !== null && <span className="alloc">{a}</span>}
                    {a === null && delta !== undefined && (
                      <span className={`delta ${delta < 0 ? 'neg' : ''}`}>{delta}</span>
                    )}
                    {sign && <span className="sign">{sign}</span>}
                  </td>
                );
              })}
              <td className="supply">{step.remainingSupply[i]}</td>
            </tr>
          ))}
          <tr>
            <th className="src-h">Demanda</th>
            {problem.dests.map((_, j) => (
              <td key={j} className="demand">
                {step.remainingDemand[j]}
              </td>
            ))}
            <td className="corner" />
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default MatrixGrid;
